import React, { useState } from "react";
import "./Faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is Hobbestie?",
      answer:
        "Hobbestie is a social platform designed to connect individuals through shared hobbies and interests. It allows users to share content, engage in discussions, build communities around their passions and have income from their passions by selling digital products.",
    },
    {
      question: "How do I get started with Hobbestie?",
      answer: "Simply sign up on our website to get started.",
    },
    {
      question: "Can I sell my products on Hobbestie?",
      answer:
        "Yes, you can sell your products on Hobbestie. Simply create a product page and list your digital products.",
    },
    {
      question: "How do I create a community on Hobbestie?",
      answer:
        "You can create a community on Hobbestie by creating a group and inviting people to join.",
    },
    {
      question: "What types of content can I share on Hobbestie?",
      answer:
        "Users can share various content formats, including photos, videos, text posts, and digital products. You can also create dedicated channels for specific hobbies to engage with like-minded individuals.",
    },
    {
      question: "How do I sell digital products on Hobbestie?",
      answer: (
        <div>
          To sell digital products:
          <ul>
            <li>
              Navigate to your profile and select the option to add a new
              product.
            </li>
            <li>Upload your digital product (e.g., e-books, art, music).</li>
            <li>Set your price and provide a description.</li>
            <li>Publish the product for your audience to purchase.</li>
          </ul>
        </div>
      ),
    },
    {
      question: "Can I create my own community or channel?",
      answer: (
        <div>
          Absolutely! Hobbesties encourages users to create custom hobby
          channels. To do so:
          <ul>
            <li>Go to the main menu and select 'Create Channel'.</li>
            <li>Name your channel and add a description.</li>
            <li>Customize it with images or banners.</li>
            <li>Invite others to join and start sharing content.</li>
          </ul>
        </div>
      ),
    },
    {
      question: "How can I customize my profile on Hobbestie?",
      answer:
        "You can customize your profile by adding a profile picture, cover photo, bio, and other personal details. By personalizing your profile with these features, you can create a distinctive presence on Hobbestie that reflects your unique interests and style.",
    },
    {
      question: "Where can I get support if I encounter issues?",
      answer:
        "For assistance, you can contact support by sending an email to support at support@hobbestie.app",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq">
      <div className="blur1"></div>
      <div className="blur2"></div>
      <div className="faq-section">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question">{faq.question}</div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
